import React, { PureComponent } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './Text.scss'

export default class Text extends PureComponent {
  render() {
    const {
      children,
      className,
      huge,
      large,
      small,
      tiny,
      alt,
      highlight,
      bold,
      error,
      inverted,
      centered,
      formatNewlines,
      onClick,
      noWrap,
      dark,
      style,
      dangerouslySetInnerHTML
    } = this.props

    const classes = cx(styles.root, {
      [styles.bold]: bold,
      [styles.alt]: alt,
      [styles.highlight]: highlight,
      [styles.huge]: huge,
      [styles.large]: large,
      [styles.small]: small,
      [styles.tiny]: tiny,
      [styles.error]: error,
      [styles.inverted]: inverted,
      [styles.centered]: centered,
      [styles.formatNewlines]: formatNewlines,
      [styles.clickable]: onClick,
      [styles.noWrap]: noWrap,
      [styles.dark]: dark,
      [className]: className
    })

    return (
      <span
        className={classes}
        style={style}
        onClick={onClick}
        dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      >
        {children}
      </span>
    )
  }
}

Text.propTypes = {
  huge: PropTypes.bool,
  large: PropTypes.bool,
  small: PropTypes.bool,
  tiny: PropTypes.bool,
  alt: PropTypes.bool,
  highlight: PropTypes.bool,
  dark: PropTypes.bool,
  inverted: PropTypes.bool,
  centered: PropTypes.bool,
  bold: PropTypes.bool,
  error: PropTypes.bool,
  dangerouslySetInnerHTML: PropTypes.shape({ __html: PropTypes.string })
}
